// extracted by mini-css-extract-plugin
module.exports = {"root":"quantity-module__root___3vMAs"};